import Repository from '../Repository';
import {
  AccessForbidden, ServerError, UserError, UserExistsError,
} from './erros';

export default {
  login(user) {
    return Repository.post('/login', user)
      .then(response => response.headers.authorization)
      .catch((error) => {
        if (error.response.status === 403) {
          throw new AccessForbidden();
        }
      });
  },
  getUser(token) {
    return Repository.get('/myaccount/changeprofile', {
      headers: {
        Authorization: token,
      },
    })
      .then(response => response.data)
      .catch((e) => {
        console.log(e);
      });
  },
  updateMyAccount(user, token) {
    return Repository.post('/myaccount/changeprofile', user, {
      headers: {
        Authorization: token,
      },
    })
      .then((response) => {

      })
      .catch((e) => {
        console.log(e);
      });
  },
  getUsersList(token) {
    return Repository.get('/administer/users', {
      responseType: 'json',
      headers: {
        Authorization: token,
      },
    })
      .then(response => response.data)
      .catch((e) => {
        console.log(e);
      });
  },
  registerUser(user, token) {
    return Repository.post('/administer/register', user, {
      headers: {
        Authorization: token,
        'Content-Type': 'application/json',
      },
    }).then((response) => {

    }).catch((e) => {
      if (e.response.status === 400) {
        if (e.response.data.code === 'USER_EXISTS') {
          throw new UserExistsError();
        }
      } else {
        throw new UserError();
      }
    });
  },
  editUser(user, token) {
    // console.log(user);
    return Repository.post('/administer/users', user, {
      headers: {
        Authorization: token,
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      // console.log(response);
    }).catch((e) => {
      throw new UserError();
    });
  },
  deleteUser(userID, token) {
    return Repository.delete(`/administer/users/${userID}`, {
      headers: {
        Authorization: token,
      },
    }).catch((error) => {
      throw new UserError();
    });
  },
  loginMockup() {
    // console.log(user);
    const ret = {
      firstName: 'Jan',
      secondName: 'Kowalski',
      login: 'dashboard@mptest.pl',
      password: null,
      phone: '7777',
      tenantId: 'Demo',
      role: 'OPTIGUARD',
    };
    // console.log(ret);
    return ret;
  },
  getUsersListMockup() {
    return [
      {
        id: 3206,
        username: 'employee1@mptest.pl',
        firstName: 'Piotr',
        secondName: 'P223',
        role: 'EMPLOYEE',
        groups: {
          1: 'Optiguard',
          2: 'test 5',
        },
        status: true,
      },
      {
        id: 3245,
        username: 'john.doe@test.com',
        firstName: 'Marcin',
        secondName: 'Doe',
        role: 'EMPLOYEE',
        groups: {
          2: 'test 5',
        },
        status: false,
      },
      {
        id: 3237,
        username: 'marcprz1111@wp.pl',
        firstName: 'Marcin',
        secondName: 'P3',
        role: 'EMPLOYEE',
        groups: {},
        status: false,
      },
      {
        id: 3239,
        username: 'marcprz1112@wp.pl',
        firstName: 'Marcin',
        secondName: 'P4',
        role: 'EMPLOYEE',
        groups: {},
        status: false,
      },
      {
        id: 3208,
        username: 'supervisor@mptest.pl',
        firstName: 'Jan',
        secondName: 'Nowak',
        role: 'SUPERVISOR',
        groups: {},
        status: true,
      },
      {
        id: 3241,
        username: 'user@user.com',
        firstName: 'Test',
        secondName: 'Test',
        role: 'EMPLOYEE',
        groups: {
          1: 'Optiguard',
          2: 'test 5',
        },
        status: false,
      },
    ];
  },
  async validateToken(token) {
    try {
      await Repository.get('/configuration', { headers: { Authorization: token } });
      return true;
    } catch (e) {
      throw new UserError();
    }
  },
  async checkTime(token) {
    try {
      const response = await Repository.get('/configuration', { headers: { Authorization: token } });
      return response.headers;
    } catch (e) {
      throw new ServerError();
    }
  },
  passwordReset(username) {
    return Repository.post('/password/forgot', username)
      .then(response => response)
      .catch((error) => {
        if (error.response.status === 500 || error.response.status === 404) {
          throw new ServerError();
        } else {
          throw new UserError();
        }
      });
  },
  passwordResetCheck(token) {
    return Repository.get(`/password/reset?token=${token}`).then(response => response).catch((error) => {
      if (error.response.status === 500 || error.response.status === 404) {
        throw new ServerError();
      } else {
        throw new UserError();
      }
    });
  },
  passwordResetSetNewPassword(payload) {
    return Repository.post('/password/reset', payload).then(response => response).catch((error) => {
      if (error.response.status === 500 || error.response.status === 404) {
        throw new ServerError();
      } else {
        throw new UserError();
      }
    });
  },
};
